import ProductFA from './fa/fa.json'

const ProductMessages = {
  fa: { ...ProductFA },
}

export default ProductMessages
